import { render, staticRenderFns } from "./territorie.vue?vue&type=template&id=2dfbc3a8&scoped=true&"
import script from "./territorie.vue?vue&type=script&lang=js&"
export * from "./territorie.vue?vue&type=script&lang=js&"
import style0 from "./territorie.vue?vue&type=style&index=0&id=2dfbc3a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfbc3a8",
  null
  
)

export default component.exports